import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Deposit from './Deposit';
import Withdrawl from './Withdrawl';
import History from './History';
import { MetaMaskContext } from '../../../../hooks/metamask';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
}));

function Wallet() {
    const metaContext = useContext(MetaMaskContext);
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        (async () => {
            await metaContext.connect();
        })();
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <div className={classes.root}>
            <AppBar
                position="static"
                color="transparent"
                backgroun="transparent"
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="white"
                    variant="primary"
                    aria-label="full width tabs"
                    centered
                >
                    <Tab label="Deposit" {...a11yProps(0)} />
                    <Tab label="Withdrawl" {...a11yProps(1)} />
                    <Tab label="History" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Deposit deposit={metaContext?.deposit} />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Withdrawl />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <History />
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}

export default Wallet;
